import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import ServiceTypeCard from './components/ServiceTypeCard';
import AdvisorCard from './components/AdvisorCard';
import BookingSummary from './components/BookingSummary';

const ServiceBooking = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [selectedAdvisor, setSelectedAdvisor] = useState(null);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [motorModel, setMotorModel] = useState('');
  const [plateNumber, setPlateNumber] = useState('');
  const [mileage, setMileage] = useState('');
  const [notes, setNotes] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [kpbLevel, setKpbLevel] = useState(null); 
  const [motorCategory, setMotorCategory] = useState(null); 


  const serviceTypes = [
    {
      id: 'service-garansi-premium',
      name: 'Service Garansi Premium (KPB)',
      description: 'Service gratis sesuai program KPB Honda untuk motor Premium',
      icon: 'Shield',
      duration: '1–2 jam',
      type: 'KPB',
      category: 'PREMIUM',
      price: 0,
      eligibleMotors: ['PCX', 'ADV 160', 'Vario 160', 'Stylo 160']
    },
    {
      id: 'service-garansi-non-premium',
      name: 'Service Garansi Non-Premium (KPB)',
      description: 'Service gratis sesuai program KPB Honda untuk motor Non-Premium',
      icon: 'Shield',
      duration: '1–2 jam',
      type: 'KPB',
      category: 'NON_PREMIUM',
      price: 0,
      eligibleMotors: ['Beat', 'Scoopy', 'Genio', 'Vario 125']
    },

    // ===== SERVICE LAIN (tetap) =====
    {
      id: 'service-reguler',
      name: 'Service Reguler',
      description: 'Service berkala berbayar untuk motor Honda',
      icon: 'Calendar',
      duration: '1–2 jam',
      type: 'REGULER',
      price: {
        nonPremium: 60000,
        premium: 90000
      }
    },
    {
      id: 'ganti-oli',
      name: 'Ganti Oli',
      description: 'Penggantian oli mesin genuine Honda',
      icon: 'Droplet',
      duration: '30 menit',
      type: 'QUICK',
      price: {
        nonPremium: 45000,
        premium: 65000
      }
    },
    {
      id: 'tune-up',
      name: 'Tune Up',
      description: 'Penyetelan mesin lengkap',
      icon: 'Settings',
      duration: '2–3 jam',
      type: 'REGULER',
      price: {
        nonPremium: 250000,
        premium: 300000
      }
    },
    {
      id: 'rem',
      name: 'Service Rem',
      description: 'Pemeriksaan dan perbaikan sistem rem',
      icon: 'Disc',
      duration: '1 jam',
      type: 'REGULER',
      price: {
        nonPremium: 100000,
        premium: 130000
      }
    }
  ];

  const advisors = [
  {
    id: 'advisor-1',
    name: 'Budi Santoso',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1f7760edb-1763292394112.png",
    photoAlt: 'Professional headshot of Indonesian male service advisor with short black hair wearing red Honda uniform polo shirt',
    experience: 8,
    specialization: 'Spesialis Motor Matic',
    rating: 5,
    totalReviews: 234,
    available: true
  },
  {
    id: 'advisor-2',
    name: 'Andi Wijaya',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1f7760edb-1763292394112.png",
    photoAlt: 'Professional headshot of Indonesian male service advisor with glasses and short black hair wearing red Honda uniform',
    experience: 6,
    specialization: 'Spesialis Motor Sport',
    rating: 5,
    totalReviews: 189,
    available: true
  },
  {
    id: 'advisor-3',
    name: 'Dewi Lestari',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_196eda338-1763293740662.png",
    photoAlt: 'Professional headshot of Indonesian female service advisor with long black hair wearing red Honda uniform',
    experience: 5,
    specialization: 'Spesialis Motor Bebek',
    rating: 5,
    totalReviews: 156,
    available: false
  },
  {
    id: 'advisor-4',
    name: 'Rudi Hartono',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_17ca71843-1763293740837.png",
    photoAlt: 'Professional headshot of Indonesian male senior service advisor with short gray hair wearing red Honda uniform',
    experience: 12,
    specialization: 'Senior Advisor - Semua Tipe',
    rating: 5,
    totalReviews: 412,
    available: true
  }];


  const selectedServiceData = serviceTypes?.find((s) => s?.id === selectedService);
  const selectedAdvisorData = advisors?.find((a) => a?.id === selectedAdvisor);

  let servicePrice = 0;
  let partsEstimate = 0;

  // KPB logic
  if (selectedServiceData?.type === 'KPB') {
    servicePrice = 0;

    if (kpbLevel === 'II' || kpbLevel === 'IV') {
      partsEstimate = motorCategory === 'PREMIUM' ? 100000 : 60000;
    }

    if (kpbLevel === 'III') {
      partsEstimate = motorCategory === 'PREMIUM' ? 150000 : 90000;
    }
  } 
  // Non-KPB (Reguler, Tune Up, Rem, dll)
  else {
    servicePrice =
      motorCategory === 'PREMIUM'
        ? selectedServiceData?.price?.premium
        : selectedServiceData?.price?.nonPremium;

    partsEstimate = 100000;
  }

  const bookingData = {
    serviceName: selectedServiceData
      ? selectedServiceData.name + (kpbLevel ? ` - KPB ${kpbLevel}` : '')
      : null,

    servicePrice: selectedServiceData ? servicePrice : 0,
    date: selectedDate,
    time: selectedTime,
    advisorName: selectedAdvisorData?.name || null,
    motorModel: motorModel || null,
    plateNumber: plateNumber || null,
    partsEstimate: selectedServiceData ? partsEstimate : 0,

    totalEstimate: selectedServiceData
      ? servicePrice + partsEstimate
      : 0
  };



  const handleConfirmBooking = () => {
    setShowConfirmation(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleEditBooking = () => {
    setShowConfirmation(false);
  };

  const handleFinalConfirm = () => {
      if (selectedServiceData?.type === 'KPB' && !kpbLevel) {
        alert('Silakan pilih jenis KPB terlebih dahulu.');
        return;
      }

      const kpbInfo =
        selectedServiceData?.type === 'KPB'
          ? `\nJenis KPB: KPB ${kpbLevel}\nKategori Motor: ${
              motorCategory === 'PREMIUM' ? 'Premium' : 'Non-Premium'
            }`
          : '';

      const message = `Halo, saya ingin booking service:\n
      Jenis Service: ${bookingData?.serviceName}
      ${kpbInfo}
      Tanggal: ${bookingData?.date}
      Waktu: ${bookingData?.time}
      Advisor: ${bookingData?.advisorName}
      Motor: ${bookingData?.motorModel}
      Plat Nomor: ${bookingData?.plateNumber}

      Mohon konfirmasi booking saya. Terima kasih!`;

        window.open(
          `https://wa.me/6288293642972?text=${encodeURIComponent(message)}`,
          '_blank'
        );
    };


  const premiumMotors = ['PCX', 'ADV', 'Vario 160', 'Stylo'];

  const detectMotorCategory = (value) => {
    if (!value) return null;

    return premiumMotors.some((m) =>
      value.toLowerCase().includes(m.toLowerCase())
    )
      ? 'PREMIUM'
      : 'NON_PREMIUM';
  };

  const isServiceEligible = (service, motorCategory) => {
    if (service.type !== 'KPB') return true;
    if (!motorCategory) return false;
    return service.category === motorCategory;
  };

  const KPB_MASTER = {
    NON_PREMIUM: {
      I: {
        interval: '1 bulan / 1.000 km',
        free: ['Gratis jasa service', 'Gratis oli mesin'],
        estimate: [],
        notes: 'Service pertama setelah pembelian motor'
      },
      II: {
        interval: '4 bulan / 4.000 km',
        free: ['Gratis jasa service'],
        estimate: ['Oli mesin', 'Oli CVT (jika diperlukan)'],
        notes: 'Oli mesin tidak termasuk program KPB'
      },
      III: {
        interval: '8 bulan / 8.000 km',
        free: ['Gratis jasa service', 'Gratis oli mesin'],
        estimate: ['Oli CVT', 'Busi (jika diperlukan)'],
        notes: 'Pemeriksaan menyeluruh komponen mesin'
      },
      IV: {
        interval: '12 bulan / 12.000 km',
        free: ['Gratis jasa service'],
        estimate: ['Oli mesin'],
        notes: 'Service terakhir dalam program KPB'
      }
    },

    PREMIUM: {
      I: {
        interval: '1 bulan / 1.000 km',
        free: ['Gratis jasa service', 'Gratis oli mesin'],
        estimate: [],
        notes: 'Service pertama motor kelas Premium'
      },
      II: {
        interval: '6 bulan / 6.000 km',
        free: ['Gratis jasa service'],
        estimate: ['Oli mesin', 'Oli CVT (jika diperlukan)'],
        notes: 'Interval lebih panjang untuk motor Premium'
      },
      III: {
        interval: '12 bulan / 12.000 km',
        free: ['Gratis jasa service', 'Gratis oli mesin'],
        estimate: ['Oli CVT', 'Busi (jika diperlukan)'],
        notes: 'Service besar motor Premium'
      },
      IV: {
        interval: '12 bulan / 12.000 km',
        free: ['Gratis jasa service'],
        estimate: ['Oli mesin'],
        notes: 'Akhir masa KPB motor Premium'
      }
    }
  };

  const isKpbService = selectedServiceData?.type === 'KPB';

  const isBookingValid =
    selectedService &&
    selectedDate &&
    selectedTime &&
    selectedAdvisor &&
    motorModel &&
    plateNumber &&
    (!isKpbService || (isKpbService && kpbLevel));

  const today = new Date().toISOString().split('T')[0];

  const maxDate = new Date(
    new Date().setDate(new Date().getDate() + 30)
  ).toISOString().split('T')[0];

  const generateTimeSlots = () => {
    const slots = [];
    for (let hour = 8; hour <= 20; hour++) {
      slots.push(`${hour.toString().padStart(2, '0')}:00`);
    }
    return slots;
  };



  

  return (
    <>
      <Helmet>
        <title>Booking Service - Honda Pamulang | Jadwalkan Service Motor Anda</title>
        <meta
          name="description"
          content="Booking service motor Honda dengan mudah di Honda Pamulang. Pilih jadwal, service advisor, dan dapatkan estimasi biaya langsung. Service berkala, ganti oli, tune up tersedia." />

      </Helmet>
      <Header />
      <main className="bg-background min-h-screen">
        {showConfirmation &&
        <div className="bg-success/10 border-b border-success/20 py-4">
            <div className="container mx-auto px-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-full bg-success flex items-center justify-center">
                    <Icon name="Check" size={20} color="white" />
                  </div>
                  <div>
                    <p className="text-sm md:text-base font-heading font-bold text-foreground">
                      Booking Berhasil Dibuat!
                    </p>
                    <p className="text-xs md:text-sm text-muted-foreground">
                      Silakan konfirmasi melalui WhatsApp untuk menyelesaikan booking Anda
                    </p>
                  </div>
                </div>
                <Button
                variant="default"
                size="default"
                iconName="MessageCircle"
                iconPosition="left"
                onClick={handleFinalConfirm}>

                  Konfirmasi via WhatsApp
                </Button>
              </div>
            </div>
          </div>
        }

        <section className="py-8 md:py-12 lg:py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center mb-8 md:mb-12" data-aos="fade-up" data-aos-delay="150">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
                Booking Service Motor
              </h1>
              <p className="text-base md:text-lg text-muted-foreground">
                Jadwalkan service motor Honda Anda dengan mudah dan cepat. Pilih waktu yang sesuai dengan jadwal Anda.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
                <div className="lg:col-span-2 space-y-8" data-aos="fade-up" data-aos-delay="200">
                  <div className="bg-card rounded-xl border border-border p-4 md:p-6">
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-6">
                      Informasi Motor
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Input
                        label="Model Motor"
                        type="text"
                        placeholder="Contoh: Honda PCX 160"
                        value={motorModel}
                        onChange={(e) => {
                          const value = e.target.value;
                          setMotorModel(value);
                          setMotorCategory(detectMotorCategory(value));
                        }}
                        required
                      />


                      <Input
                      label="Nomor Plat"
                      type="text"
                      placeholder="Contoh: B 1234 XYZ"
                      value={plateNumber}
                      onChange={(e) => setPlateNumber(e?.target?.value)}
                      required />

                      <Input
                      label="Kilometer Saat Ini"
                      type="number"
                      placeholder="Contoh: 15000"
                      value={mileage}
                      onChange={(e) => setMileage(e?.target?.value)} />

                    </div>
                    <div className="mt-4">
                      <label className="block text-sm font-medium text-foreground mb-2">
                        Catatan Tambahan
                      </label>
                      <textarea
                      value={notes}
                      onChange={(e) => setNotes(e?.target?.value)}
                      placeholder="Jelaskan keluhan atau permintaan khusus Anda..."
                      rows={4}
                      className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all" />

                    </div>
                  </div>

                  <div className="bg-card rounded-xl border border-border p-4 md:p-6">
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-6">
                      Pilih Jenis Service
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {serviceTypes.map((service) => {
                      const disabled = !isServiceEligible(service, motorCategory);

                      return (
                        <ServiceTypeCard
                          key={service.id}
                          service={service}
                          isSelected={selectedService === service.id}
                          onSelect={() => {
                            if (!disabled) {
                              setSelectedService(service.id);
                              setKpbLevel(null);
                            }
                          }}
                          disabled={disabled}
                          warningMessage={
                            disabled && service.type === 'KPB'
                              ? `Hanya untuk motor ${
                                  service.category === 'PREMIUM' ? 'Premium' : 'Non-Premium'
                                }`
                              : null
                          }
                          kpbLevel={kpbLevel}
                          onKpbChange={setKpbLevel}
                          kpbMaster={KPB_MASTER}   // 🔥 INI KUNCINYA
                        />
                      );
                    })}


                    </div>

                    {/* Dropdown KPB */}
                    {selectedService === 'service-garansi' && (
                      <div className="mt-6">
                        <label className="block text-sm font-medium text-foreground mb-2">
                          Pilih Jenis KPB
                        </label>
                        <select
                          value={kpbLevel || ''}
                          onChange={(e) => setKpbLevel(e.target.value)}
                          className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
                        >
                          <option value="">Pilih KPB</option>
                          <option value="I">KPB I</option>
                          <option value="II">KPB II</option>
                          <option value="III">KPB III</option>
                          <option value="IV">KPB IV</option>
                        </select>

                        {motorCategory && (
                          <p className="mt-2 text-xs text-muted-foreground">
                            Kategori motor terdeteksi:{" "}
                            <span className="font-semibold">
                              {motorCategory === 'PREMIUM' ? 'Premium' : 'Non-Premium'}
                            </span>
                          </p>
                        )}
                      </div>
                    )}

                  </div>

                  <div className="bg-card rounded-xl border border-border p-4 md:p-6">
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-6">
                      Pilih Service Advisor
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {advisors?.map((advisor) =>
                    <AdvisorCard
                      key={advisor?.id}
                      advisor={advisor}
                      isSelected={selectedAdvisor === advisor?.id}
                      onSelect={setSelectedAdvisor} />

                    )}
                    </div>
                  </div>

                  <div className="bg-card rounded-xl border border-border p-4 md:p-6">
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-6">
                      Pilih Jadwal
                    </h2>

                    {/* PILIH TANGGAL */}
                    <div className="mb-6">
                      <label className="block text-sm font-medium text-foreground mb-2">
                        Pilih Tanggal
                      </label>
                      <input
                        type="date"
                        value={selectedDate}
                        min={today}
                        max={maxDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        className="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground
                          focus:outline-none focus:ring-2 focus:ring-primary"
                      />
                    </div>

                    {/* PILIH WAKTU */}
                    <div>
                      <label className="block text-sm font-medium text-foreground mb-2">
                        Pilih Waktu
                      </label>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                        {generateTimeSlots().map((time) => (
                          <button
                            key={time}
                            type="button"
                            onClick={() => setSelectedTime(time)}
                            className={`p-3 rounded-lg border text-sm font-semibold transition-all
                              ${
                                selectedTime === time
                                  ? 'bg-primary text-primary-foreground border-primary'
                                  : 'bg-card border-border hover:border-primary'
                              }`}
                          >
                            {time}
                          </button>
                        ))}
                      </div>
                    </div>

                    
                  </div>
                </div>

                <div className="lg:col-span-1" data-aos="fade-left" data-aos-delay="200">
                  <BookingSummary
                    bookingData={bookingData}
                    onConfirm={handleConfirmBooking}
                    onEdit={handleEditBooking}
                    isDisabled={!isBookingValid}
                  />


                </div>
              </div>

          </div>
        </section>

        <section className="py-12 md:py-16 bg-muted">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4" data-aos="fade-up" data-aos-delay="150">
                  Mengapa Pilih Service di Honda Pamulang?
                </h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-aos="zoom-in" data-aos-delay="150">
                {[
                {
                  icon: 'Award',
                  title: 'Teknisi Bersertifikat',
                  description: 'Teknisi terlatih dan bersertifikat resmi Honda dengan pengalaman bertahun-tahun'
                },
                {
                  icon: 'Shield',
                  title: 'Suku Cadang Original',
                  description: 'Hanya menggunakan suku cadang genuine Honda dengan garansi resmi'
                },
                {
                  icon: 'Clock',
                  title: 'Service Cepat',
                  description: 'Proses service efisien dengan estimasi waktu yang akurat dan tepat'
                },
                {
                  icon: 'Wrench',
                  title: 'Peralatan Modern',
                  description: 'Dilengkapi dengan peralatan service terkini sesuai standar Honda'
                },
                {
                  icon: 'Users',
                  title: 'Layanan Ramah',
                  description: 'Service advisor profesional siap membantu dengan penjelasan detail'
                },
                {
                  icon: 'CheckCircle',
                  title: 'Garansi Service',
                  description: 'Garansi untuk setiap pekerjaan service dan suku cadang yang diganti'
                }]?.
                map((feature, index) =>
                <div
                  key={index}
                  className="bg-card rounded-xl border border-border p-6 hover:shadow-card-hover transition-shadow">

                    <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                      <Icon name={feature?.icon} size={28} color="var(--color-primary)" />
                    </div>
                    <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                      {feature?.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">{feature?.description}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto bg-primary rounded-2xl p-8 md:p-12 text-center" data-aos="zoom-in-up" data-aos-delay="150">
              <Icon name="MessageCircle" size={48} color="white" className="mx-auto mb-6" />
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-foreground mb-4">
                Butuh Bantuan dengan Booking?
              </h2>
              <p className="text-base md:text-lg text-primary-foreground/90 mb-8">
                Tim kami siap membantu Anda menjadwalkan service motor dengan mudah dan cepat
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Button
                  variant="secondary"
                  size="lg"
                  iconName="MessageCircle"
                  iconPosition="left"
                  onClick={() => window.open('https://wa.me/6288293642972', '_blank')}>

                  Chat WhatsApp
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Phone"
                  iconPosition="left"
                  onClick={() => window.open('tel:+6288293642972', '_blank')}
                  className="bg-white hover:bg-white/90 text-primary border-white">

                  Hubungi Kami
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>);

};

export default ServiceBooking;